export default "__VITE_ASSET__CgNNL2vD__"